import { render, staticRenderFns } from "./DatosCompania.vue?vue&type=template&id=08f89493"
import script from "./DatosCompania.vue?vue&type=script&lang=js"
export * from "./DatosCompania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports